import { RemoteHandleActivitiesQuantityPerStudent } from 'data/usecases';
import { HandleActivitiesQuantityPerStudentUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivitiesQuantityPerStudent } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleActivitiesQuantityPerStudent =
  (): HandleActivitiesQuantityPerStudentUseCaseInterface =>
    new RemoteHandleActivitiesQuantityPerStudent(
      makeApiUrlActivitiesQuantityPerStudent(),
      makeAxiosHttpClient(),
    );
